import * as api from '$lib/shared/apis';

const authHeaders = { Authorization: 'Bearer 2pAZzQbGZfLtWiAtVa0xu0QBT9kcQCUbmB0s6Tt6' };

export const getObject = async (id: number) => {
	const { response, json } = await api.post(
		{
			query: /* GraphQL */ `
				query object($objectId: Int!) {
					object(objectId: $objectId) {
						id
						... on Letter {
							author
							authorGnd
							authorWienGeschichteWikiUrl
							recipient
							recipientGnd
							recipientWienGeschichteWikiUrl
							date
							address
							incipit
							link
						}
						images {
							preview {
								webp
								width
								height
							}
							default {
								webp
								width
								height
							}
							full {
								webp
								width
								height
							}
						}
					}
				}
			`,
			variables: {
				objectId: id,
			},
		},
		authHeaders
	);

	if (response.status === 200) {
		return json.data.object as ObjectType;
	}
};

export const getObjects = async (projectName) => {
	const size = 1000;
	let skip = 0;
	let objects = [];
	let done = false;

	if (!projectName) {
		console.error('ERROR: No project name!');
		return;
	}
	while (!done) {
		const { response, json } = await api.post(
			{
				query: /* GraphQL */ `
					query objects($projectName: ProjectName!, $size: Int!, $skip: Int!) {
						objects(pagination: { size: $size, skip: $skip }, project: $projectName) {
							objects {
								id
							}
						}
					}
				`,
				variables: {
					projectName,
					size,
					skip,
				},
			},
			authHeaders
		);

		if (!response.ok) {
			throw new Error('error fetching objects');
		}

		if (json.errors) {
			throw new Error(json.errors.map((e) => e.message).join(';'));
		}

		if (response.status === 200) {
			objects = [...objects, ...json.data.objects.objects];
		}

		skip += size;
		done = objects.length === json.data.objects.total;
	}

	return objects;
};

export const getLeaderboard = async (size = 50, skip = 0): Promise<Leaderboard> => {
	const { response, json } = await api.post({
		query: /* GraphQL */ `
			query leaderboard($size: Int!, $skip: Int!, $projectName: ProjectName!) {
				leaderboard(pagination: { size: $size, skip: $skip }, project: $projectName) {
					total
					users {
						id
						name
						statistics {
							submissions
							approvals
							objects(pagination: { size: 1, skip: 0 }) {
								id
								images {
									preview {
										webp
										width
										height
									}
								}
							}
						}
					}
				}
			}
		`,
		variables: {
			size,
			skip,
			projectName: import.meta.env.VITE_PROJECT_NAME,
		},
	});

	if (response.status === 200) {
		return json.data?.leaderboard;
	}
};
